module.exports = __webpack_public_path__ + "static/media/leaderboard_background.fe43b394.png";